import { h, Fragment } from "preact";
import { useState, useEffect, } from "preact/hooks";
import {
	Divider,
	Stack,
	Typography,
} from "@mui/material";

import FormField from "../Common/FormField";

import FormToggle from "../Common/FormToggle";
import FormMultiToggle from "../Common/FormMultiToggle";
import FormDate from "../Common/FormDate";


export default function Lot({ upperState, upperHandleChange }) {
	const [state, setState] = useState({ changes: false });


	const handleChange = (event) => {

		upperHandleChange(event);
	};

	console.log("render lot", state);
	return (
		<Stack spacing={1}>

			<Stack>
				<FormToggle upperState={upperState} id="co_property" handleChange={handleChange} />

				{upperState.co_property == "O" && (<FormField upperState={upperState} id="co_property_lots" placeholder="No" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer le numéro de lot de copropriété du parking.</Typography></Stack>} />)}
				<Divider />
				<FormToggle upperState={upperState} id="parking_fenced" handleChange={handleChange} />
				<Divider />
				<FormToggle upperState={upperState} id="parking_covered" handleChange={handleChange} />
				<Divider />
				<FormMultiToggle upperState={upperState} options={[{ o: "49", l: "Avant 1949" }, { o: "97", l: "Entre les deux" }, , { o: "00", l: "Après 1996" }, { o: "?", l: "Ne sais pas" }]} id="construction_year" handleChange={handleChange} exclusive={true} helper={<Stack><Typography>Indiquer la période de construction de l'immeuble.</Typography></Stack>} />
				<Divider />
				<FormToggle upperState={upperState} id="is_not_free" handleChange={handleChange} helper={<Stack><Typography>Indiquez si le bien fait l'objet d'un contrat de location.</Typography></Stack>} />
				{upperState.is_not_free == "O" && (<FormField upperState={upperState} id="rent" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer le montant du loyer annuel hors charges.</Stack>} />)}
				{upperState.is_not_free == "O" && (<FormDate upperState={upperState} id="rent_term" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer la date de fin du contrat de location (bail).</Stack>} />)}
			</Stack>


		</Stack>
	);
}
